import React, { useReducer } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import PublicRoute from './PublicRoute'
import PrivateRoute from './PrivateRoute'
import AdminRoute from './AdminRoute'
import Home from '../components/home/Home'
import Management from '../components/management/Management'
import UserCreate from '../components/management/users/UserCreate/UserCreate'
import UserUpdate from '../components/management/users/UserUpdate/UserUpdate'
import ConversationDetails from '../components/conversationDetails/ConversationDetails'
import UsersManagement from '../components/management/users/UsersManagement/UsersManagement'
import ConversationAttributes from '../components/conversationAttributes/conversationAttributes'
import AccessReport from '../components/audits/accessReport/AccessReport'
import Download from '../components/download/Download'
//import CommonSearchTerms from '../components/audits/commonSearchTerms/CommonSearchTerms'
import Main from '../components/Main'
import Unauthorized from '../components/unauthorized/Unauthorized'
import SessionReducer from '../components/reducers/session'
import SessionContext from '../components/context/session'
import PrivacyDisclaimer from '../components/privacyDisclaimer/PrivacyDisclaimer'
import PureCloudLogin from "../components/login/purecloud/PureCloudLogin";
import GCAuthPopup from "../components/gcAuthPopup/GCAuthPopup";
import { Box, CssBaseline, Toolbar, Backdrop, CircularProgress } from '@mui/material';
// Third Party
import { themeOptions } from '../routers/theme'
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';

const AppRouter = () => {
    const [session, dispatch] = useReducer(SessionReducer, [])
    const theme = useTheme();
    const genesysTheme = React.useMemo(
        () => createTheme(theme, themeOptions)
    );
    return (
        <SessionContext.Provider value={{ session, dispatch }}>
            <BrowserRouter>
                <ThemeProvider theme={genesysTheme}>
                    <Routes>
                        <Route path="/" element={<PublicRoute component={Main} />} />
                        <Route path="/disclaimer" element={<PublicRoute component={PrivacyDisclaimer} />} />
                        <Route path="/unauthorized" element={<PublicRoute component={Unauthorized} />} />
                        <Route path="/auth" element={<PublicRoute component={GCAuthPopup} />} />
                        <Route path="/conversations" element={<PrivateRoute component={Home} />} />
                        <Route path="/conversations/:id/details" element={<PrivateRoute component={ConversationDetails} />} />
                        <Route path="/management/searchview" element={<AdminRoute component={ConversationAttributes} />} />
                        <Route path="/management" element={<AdminRoute component={Management} />} />
                        {/*
                        <Route path="/management/users/" element={<AdminRoute component={UsersManagement} />} />
                        <Route path="/management/users/create" element={<AdminRoute component={UserCreate} />} />
                        <Route path="/management/users/update/:id" element={<AdminRoute component={UserUpdate} />} />
                        */}
                        <Route path="/audits/access/" element={<AdminRoute component={AccessReport} />} />
                        <Route path="/downloads/" element={<PrivateRoute component={Download} />} />
                        <Route path="*" element={<Navigate to="/" replace />} /> {/* Catch-all route */}
                    </Routes>
                </ThemeProvider>
            </BrowserRouter>
        </SessionContext.Provider>
    )
}

export default AppRouter